import { Reveal, Overline } from "@/components/Reveal";
import VideoPlayer from "@/components/VideoPlayer";
import { VIDEOS } from "@/lib/constants";

export default function VideoShowcase() {
  return (
    <section id="showcase" className="relative bg-black py-24 lg:py-32" data-testid="video-showcase-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Overline>In Motion</Overline>
          <h2 className="mt-3 font-display text-5xl leading-none tracking-tight text-cream sm:text-7xl lg:text-8xl">
            WATCH THE <span className="text-gold-gradient">CRUNCH</span>
          </h2>
          <p className="mt-4 max-w-lg text-white/50">
            Real product, real crunch. Tap the sound icon to hear it, or tap the video to pause.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 lg:grid-cols-3 lg:auto-rows-[240px]">
          <VideoPlayer src={VIDEOS.modelBeetroot} label="Beetroot Soya Nachos" tag="Featured"
            className="aspect-[4/5] lg:col-span-2 lg:row-span-2 lg:aspect-auto" />
          <VideoPlayer src={VIDEOS.beetroot} label="Straight From The Jar"
            className="aspect-video lg:aspect-auto" />
          <VideoPlayer src={VIDEOS.beetroot2} label="Bold Colour. Bold Taste."
            className="aspect-video lg:aspect-auto" />
        </div>
      </div>
    </section>
  );
}
